import { ReactNode } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { SxProps } from "@mui/material/styles";

interface HeaderDetailProps {
  value: string | null | undefined | ReactNode;
  label?: ReactNode | string;
  emptyValueText?: string;
  sx?: SxProps;
}

export default function HeaderDetail({
  label,
  value,
  emptyValueText = "-",
  sx
}: HeaderDetailProps) {
  return (
    <Box data-testid="patient-profile-header-detail" sx={sx}>
      {Boolean(label) && typeof label === "string" ? (
        <Typography variant="caption" component="div" color="textSecondary">
          {label}
        </Typography>
      ) : (
        <>{label ?? null}</>
      )}
      <Typography
        variant="body1"
        component="div"
        fontWeight={600}
        color="textSecondary"
      >
        {value || emptyValueText}
      </Typography>
    </Box>
  );
}
